import React from 'react';
import { DEV_SUMMARY_CF_TYPE } from '@atlassian/jira-platform-field-config';
import { CellWrapper } from '../../../common/cell-wrapper';
import type { TransformedDevSummary } from '../../../common/field-types/dev-summary';
import type { FieldCellProps, BasicListViewItem } from '../../../common/types';
import { DevSummaryRead } from './read';

export const DevSummaryCell = ({
	rowData,
	cellData,
	editMode,
	setEditMode,
	cellRef,
}: FieldCellProps<BasicListViewItem, TransformedDevSummary>) => (
	<CellWrapper isEditable={false}>
		{cellData && (
			<DevSummaryRead
				{...cellData}
				isHovering={false}
				issueId={rowData.issueId}
				editMode={editMode}
				setEditMode={setEditMode}
				cellRef={cellRef}
			/>
		)}
	</CellWrapper>
);

export const devSummaryCellHandler = {
	[DEV_SUMMARY_CF_TYPE]: DevSummaryCell,
};
